import { Stack, Typography, useTheme, Divider } from '@mui/material'
import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';
import SelectNetwork from '@/pages/Deposit/components/SelectNetwork/index.tsx'

import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import { useDepositInit } from '../hooks'
import { getUrlParams } from "@/utils/utils";

import mobileClasses from "./mobile.module.css";
import CopyButton from "@/components/CopyButton";
import PageBack from "@/components/PageBack";
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import { useKeepAliveContext } from "@hhhgamehhh/keepalive-for-react";
import OpenOrDownloadApp from "@/components/OpenOrDownloadApp";
import useSonicMigrateIntercept from "@/hook/useSonicMigrateIntercept";

const DepositPage = () => {
  const paramVarietyCode = getUrlParams("variety_code");
  const [_paramVarietyCode, setParamVarietyCode] = useState(paramVarietyCode);
  const theme = useTheme()
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectetNetwork, setSelectedNetwork] = useState(null);
  const [coin, setCoin] = useState('');
  const [varietyCode, setVarietyCode] = useState(paramVarietyCode);
  const [addressInfo, setAddressInfo] = useState(null);

  const { refresh, destroy } = useKeepAliveContext();
  const { showAppStoreModal, setShowAppStoreModal, interceptAction } = useSonicMigrateIntercept();

  // const userHomeReq = useUserVariteies()
  const { user, isAuthenticated, homeInfo } = useSelector((state) => state.user);
  const getDepositInitInfoReq = useDepositInit(varietyCode, coin)
  const depositVariety = useMemo(() => {
    if (!homeInfo) {
      return null
    }
    const _ret = homeInfo?.assetUser.accountList.find(_ => {
      return _.varietyCode == varietyCode
    })
    return _ret
  }, [varietyCode, homeInfo])

  useEffect(() => {
    if (_paramVarietyCode) {
      getDepositInitInfoReq.runAsync(_paramVarietyCode)
    }

  }, [_paramVarietyCode]);

  useEffect(() => {
    if (selectetNetwork) {
      setCoin(selectetNetwork.coin)
      setAddressInfo(null)
      getDepositInitInfoReq.runAsync(paramVarietyCode, selectetNetwork.coin).then((data) => {
        const _address = data.addressList.find(_ => _.coin == selectetNetwork.coin)
        if (_address) {
          setAddressInfo(_address)
        }
      })
    }
  }, [selectetNetwork]);

  return (<>
    <Stack
      className={mobileClasses.root}>
      <SimpleHeader
        closeButton={
          <RpIcon icon="arrow-left" clickable
            onClick={() => {
              destroy()
              navigate(-1)
            }} />
        }
        backEnable
      />
      <Stack sx={{ padding: '0 16px 16px' }}>
        <Typography fontSize={'28px'} fontWeight={700}>
          {t('deposit')} {depositVariety ? depositVariety.shortName : ''}
        </Typography>
        <Stack
          direction="column" justifyContent="center"
          className={mobileClasses.varieties}>
          <SelectNetwork autoShow variety={depositVariety} depositInfo={getDepositInitInfoReq?.data}
            onSelected={() => {
              interceptAction();
            }}
          />
          {addressInfo && <Stack
            direction="column" alignItems="center"
            sx={theme => ({ marginTop: '40px', gap: '24px' })}
          >
            {addressInfo.depositAddress && <Stack sx={{ position: 'relative' }}>
              <QRCodeSVG
                value={addressInfo.depositAddress}  //想要生成二维码的内容
                size={200} //大小
                style={{
                  border:"1px solid #FFFFFF",
                }}
                // fgColor={theme.palette.text.primary}  //颜色
              />
              {_paramVarietyCode && <img
                style={{ width: '40px', height: '40px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                src={`/images/coin/${_paramVarietyCode.toLowerCase()}.png`}
                alt={`${_paramVarietyCode}.png`} />}
            </Stack>}

            {addressInfo.depositAddress && <Stack direction="row" gap={'20px'}
              sx={theme => {
                return {
                  height: '72px',
                  padding: '0 16px',
                  alignItems: 'center',
                  backgroundColor: theme.palette.background.card
                }
              }}
            >
              <Typography
                sx={{ flex: 1, wordBreak: 'break-all' }}
              >{addressInfo?.depositAddress}</Typography>
              <Divider variant="middle" orientation="vertical" flexItem />
              {addressInfo?.depositAddress && <CopyButton value={addressInfo?.depositAddress} />}
            </Stack>}
            <Stack direction="column" gap={'20px'}
              sx={theme => {
                return {
                  width: '100%',
                  padding: '16px',
                  backgroundColor: theme.palette.background.card
                }
              }}
            >
              <Stack direction="row" justifyContent="space-between">
                <Typography sx={theme => ({
                  fontWeight: 400,
                  color: theme.palette.text.secondary,
                })}>{t('deposit_network')}</Typography>
                <Typography>{selectetNetwork?.displayName}</Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography sx={theme => ({
                  fontWeight: 400,
                  color: theme.palette.text.secondary,
                })}>{t('minimum_deposit')}</Typography>
                <Typography>{getDepositInitInfoReq?.data.depositMin} {depositVariety.shortName}</Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography sx={theme => ({
                  fontWeight: 400,
                  color: theme.palette.text.secondary,
                })}>{t('deposit_arrival')}</Typography>
                <Typography>{t('confirmations', { confirmations: selectetNetwork?.confirmations })}</Typography>
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" gap={'20px'}
              sx={theme => {
                return {
                  width: '100%',
                  padding: '16px',
                  backgroundColor: theme.palette.background.card
                }
              }}
            >
              <RpIcon icon={'info'} size={24} />
              <Typography sx={theme => ({
                fontWeight: 400,
                color: theme.palette.text.secondary,
              })}>
                {t('current_address_supports_depositing', {
                  varietyCode: varietyCode.toUpperCase(),
                  displayName: selectetNetwork?.displayName
                })}
              </Typography>
            </Stack>
          </Stack>}
        </Stack>

      </Stack>

    </Stack>
    <OpenOrDownloadApp
      open={showAppStoreModal}
      onClose={() => setShowAppStoreModal(false)}
    />
  </>)
}

export default DepositPage;